export default __webpack_public_path__ + "static/media/quickdraw-manual-entry.8b3d1bd7.webm";